import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, interval, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ChargeService } from 'src/app/services/charge.service';
import { TankService } from 'src/app/services/tank.service';
import { Charge } from 'src/app/shared/models/Charge';
import { Tank } from 'src/app/shared/models/Tank';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-list-charges-page',
  templateUrl: './list-charges-page.component.html',
  styleUrls: ['./list-charges-page.component.css']
})
export class ListChargesPageComponent implements OnInit, OnDestroy {
  charges: Charge[] = [];
  currentTank: Tank;
  available: number;
  private refreshSubscription: Subscription;

  constructor(private chargeService: ChargeService, private tankService: TankService) { }

  ngOnInit() {
    // Al inicializar el componente, primero obtenemos el tanque actual.
    this.tankService.getCurrentTank().subscribe((tank) => {
      this.currentTank = tank;
      // Después de obtener el tanque, obtenemos la lista de cargos.
      this.listCharges();
    });

    this.tankService.getTank(this.currentTank.id).subscribe((avaliableTank) => {
      this.available = avaliableTank.available;
    })
    this.startAutoRefresh();

  }

  ngOnDestroy() {
    // Detén la actualización periódica al destruir el componente
    this.stopAutoRefresh();
  }

  private startAutoRefresh() {
    // Realiza una consulta cada 2 segundos para obtener el estado actualizado del tanque
    this.refreshSubscription = interval(2000)
      .pipe(
        switchMap(() => this.tankService.getTank(this.currentTank.id))
      )
      .subscribe((avaliableTank) => {
        this.available = avaliableTank.available;
      });
  }

  private stopAutoRefresh() {
    // Detiene la actualización periódica al destruir el componente
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }




  listCharges() {
    if (this.currentTank) {
      this.chargeService.getChargeByTank(this.currentTank.id).subscribe(
        (data) => {
          this.charges = data;
          console.log("Charges: ", this.charges);
        },
        (error) => {
          console.log(error);
        }
      );
    } else {
      console.error('No se ha obtenido el tanque actual.');
    }
  }

  deleteCharge(id: any) {
    this.chargeService.deleteCharge(id).subscribe(
      (data) => {
        this.listCharges(); // Actualizar la lista de cargos después de eliminar uno.
      },
      (error) => {
        console.log(error);
      }
    );
  }

  exportToExcel() {
    const excelData = this.charges.map(charge => ({
      Fecha: new Date(charge.dateTime).toLocaleString(),
      Usuario: charge.user_name,
      Tipo: charge.chargeType,
      Cantidad: charge.amount,
      Proveedor: charge.businessName,
      Cuit: charge.cuitNumber,
      Chofer: charge.driverName,
      Patente: charge.vehiclePlate,
      Factura: charge.invoiceNumber
    }));

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Cargas');

    XLSX.writeFile(wb, 'cargas.xlsx');
  }
}
